import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import logoImg from '../../logo.png';

export default function Login() {
  const { login, loading } = useAuth();
  const [email, setEmail] = useState('admin@osg.uz');
  const [password, setPassword] = useState('admin123');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError('Заполните все поля'); return; }
    const ok = await login(email, password);
    if (!ok) setError('Неверные данные');
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1A1A2E 0%, #16213E 50%, #0F3460 100%)',
      padding: 20,
    }}>
      {/* Background pattern */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.05,
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px',
      }} />
      <div style={{
        position: 'relative', background: '#fff', borderRadius: 20, padding: 40,
        width: '100%', maxWidth: 420,
        boxShadow: '0 24px 80px rgba(0,0,0,0.4)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          {/* Full logo */}
          <div style={{ marginBottom: 14 }}>
            <img src={logoImg} alt="OSG Logo" style={{ height: 52, objectFit: 'contain' }} />
          </div>
          <p style={{ color: '#8E8E93', fontSize: 14 }}>Control Panel Administration</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Input
            label="Email" type="email" value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="admin@osg.uz" required
            icon={<Mail size={15} />}
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
              Пароль <span style={{ color: '#FF3B30' }}>*</span>
            </label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF', display: 'flex' }}>
                <Lock size={15} />
              </span>
              <input
                type={showPass ? 'text' : 'password'}
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '8px 38px 8px 34px',
                  border: '1px solid #E5E7EB', borderRadius: 8, fontSize: 13,
                  color: '#1A1A2E', background: '#fff', outline: 'none', fontFamily: 'inherit',
                }}
              />
              <button type="button" onClick={() => setShowPass(v => !v)} style={{
                position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', display: 'flex',
              }}>
                {showPass ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>
          {error && (
            <div style={{ padding: '10px 14px', background: '#FFF0F0', borderRadius: 8, fontSize: 13, color: '#FF3B30', borderLeft: '3px solid #FF3B30' }}>
              {error}
            </div>
          )}
          <Button type="submit" size="lg" disabled={loading} style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}>
            {loading ? 'Вход...' : 'Войти в систему'}
          </Button>
        </form>

        <div style={{ marginTop: 24, padding: 16, background: '#F5F6FA', borderRadius: 10 }}>
          <p style={{ fontSize: 12, color: '#6B7280', marginBottom: 4 }}>Тестовый доступ:</p>
          <p style={{ fontSize: 12, color: '#374151', fontFamily: 'monospace' }}>admin@osg.uz / admin123</p>
        </div>
      </div>
    </div>
  );
}
